module.exports = __webpack_public_path__ + "img/manet_3.148d1813.jpg";